import { createReducer, on } from '@ngrx/store';
import { setSessionRefresh } from './session-refresh.actions';

const initialState = false;

export const reducer = createReducer<boolean>(
  initialState,
  on(setSessionRefresh, (actualState, { payload }) => (payload.state === true || payload.state === false ? payload.state : actualState))
);
